module.exports = "/_next/static/images/90bf2b9bc17832f557fc704d769057f1-open-graph-mgm-large.jpg.webp";